import React from 'react';

import { Icon } from '@chakra-ui/react';

export const SyncRestartIcon = props => (
  <Icon viewBox="0 0 145 145" color="inherit" h="full" w="full" {...props}>
    <g transform="translate(-733 -177)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M781.56 242.155 779.44 240.033 760.422 259.051C760.417 259.057 760.407 259.057 760.401 259.051 760.399 259.049 760.397 259.045 760.397 259.042 755.385 233.855 771.74 209.373 796.928 204.361 817.942 200.18 839.093 210.898 848.147 230.317L850.865 229.046C839.345 204.26 809.914 193.506 785.128 205.026 765.236 214.271 753.804 235.505 757.037 257.2 757.04 257.207 757.036 257.215 757.029 257.217 757.023 257.22 757.016 257.217 757.013 257.212L739.836 240.033 737.716 242.155 759.638 264.077Z"
                stroke="currentColor"
                strokeWidth="2.5263"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M830.44 260.896 832.56 263.017 852 243.577C852.006 243.571 852.016 243.571 852.022 243.577 852.024 243.579 852.026 243.583 852.026 243.586 855.677 268.897 838.118 292.375 812.808 296.026 810.553 296.351 808.278 296.51 806 296.5 788.785 296.516 772.973 287.009 764.914 271.797L762.265 273.203C775.068 297.358 805.029 306.56 829.183 293.756 845.381 285.17 855.508 268.333 855.5 250 855.5 248.744 855.442 247.488 855.35 246.235 855.35 246.227 855.357 246.22 855.365 246.22 855.368 246.22 855.371 246.221 855.374 246.223L872.167 263.023 874.287 260.902 852.362 238.972Z"
                stroke="currentColor"
                strokeWidth="2.5263"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
